import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSpinner,
  faTimes,
  faTimesCircle,
  faEdit,
  faCopy,
  faLink,
  faCheckCircle,
  faArrowDown,
  faArrowUp,
  faArrowsAltV,
  faCheck,
  faInfo,
  faEllipsisH,
  faInfoCircle,
  faEye,
  faLock,
  faLockOpen,
  faStickyNote,
  faFileExport,
  faUserTimes,
  faUsers,
  faUserCheck,
  faChevronDown,
  faChevronRight,
  faTrashRestore,
  faAddressCard,
  faBell,
  faBellSlash,
  faSync,
  faExclamationTriangle,
  faUtensils,
  faPlus,
  faSlidersH,
  faDownload,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faSpinner,
  faTimes,
  faTimesCircle,
  faEdit,
  faCopy,
  faLink,
  faCheckCircle,
  faArrowDown,
  faArrowUp,
  faArrowsAltV,
  faCheck,
  faInfo,
  faEllipsisH,
  faInfoCircle,
  faEye,
  faLock,
  faLockOpen,
  faStickyNote,
  faFileExport,
  faUserTimes,
  faUserCheck,
  faUsers,
  faChevronDown,
  faChevronRight,
  faTrashRestore,
  faAddressCard,
  faBell,
  faBellSlash,
  faSync,
  faExclamationTriangle,
  faUtensils,
  faPlus,
  faSlidersH,
  faDownload,
  faMapMarkerAlt,
);
